var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFundoDourado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 327,
    viewBox: "0 0 375 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-8.22544e-06 0H379V220H-8.22544e-06V0Z",
    fill: "url(#paint0_linear_31_402)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 313L-1.72656 219.25L376.727 219.25L187.5 313Z",
    fill: "url(#paint1_linear_31_402)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.5 226.5L188 326L383.5 226.5",
    stroke: "#F4D89B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_402",
    x1: 188.637,
    y1: 0,
    x2: 188.637,
    y2: 313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D89B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#C39B45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_402",
    x1: 188.637,
    y1: 0,
    x2: 188.637,
    y2: 313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D89B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#C39B45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9036"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundoDourado);
export default __webpack_public_path__ + "static/media/fundo_dourado.95e39eee97b4585ea8036d5db9a1c0d7.svg";
export { ForwardRef as ReactComponent };